import axios from 'axios';
import { DocumentType, setDocumentTypes } from '../utils/documentTypes';

// Get the API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * Fetch document types from the backend API
 * @returns Promise that resolves to an array of document types
 */
export const fetchDocumentTypes = async (): Promise<DocumentType[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/document-types`);
    if (response.data.success) {
      // Store document types in our utility
      setDocumentTypes(response.data.document_types);
      return response.data.document_types;
    } else {
      console.error('Failed to fetch document types:', response.data.message);
      return [];
    }
  } catch (error) {
    console.error('Error fetching document types:', error);
    return [];
  }
};

/**
 * Initialize document types on application startup
 * This should be called once when the application loads
 */
export const initializeDocumentTypes = async (): Promise<void> => {
  await fetchDocumentTypes();
}; 